import { Component, computed, signal, WritableSignal } from '@angular/core';
import { Button } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { QrScannerComponent } from '../../shared/qr-scanner/qr-scanner.component';
import { QrReaderService } from '../../services/qr-reader.service';
import { DatePipe, NgIf } from '@angular/common';
import { IShipment } from '../../interfaces/IShipment';
import { DbService } from '../../services/db.service';
import { ToastService } from '../../services/toast.service';
import { Router } from '@angular/router';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { IDeliveryStatus } from '../../interfaces/IDeliveryStatus';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-shipment',
  standalone: true,
  imports: [ToolbarModule, Button, QrScannerComponent, NgIf, IconFieldModule, InputIconModule, FormsModule,InputTextModule,SelectButtonModule, CardModule,ChipModule, DatePipe],
  templateUrl: './shipment.component.html',
  styleUrl: './shipment.component.scss'
})
export class ShipmentComponent {
  private readonly pendingShipmentIdKey = 'pending_shipment_id';

  constructor(private qrReaderService:QrReaderService, private dbService: DbService, 
              private toastService: ToastService, private router: Router,
              private route: ActivatedRoute ) {}
  isCameraOpen:boolean = false;
  statusAll:IDeliveryStatus = { id: 0, status: 'All' } as IDeliveryStatus;
  shipmentList = signal<IShipment[]>([]);
  searchText = signal<string>("");
  selectedStatus =signal<string | null>(null);  

  statusList = computed(() => {
    let status = this.shipmentList().reduce((acc: IDeliveryStatus[], shipment) => {        
          if (!acc.some(status => status.id === shipment.deliveryStatus.id)) {
            acc.push(shipment.deliveryStatus);
          }
        return acc;
      }, []); 
    status.unshift(this.statusAll);
    return status;
  });

  shimentListFilter = computed(() => {
    const search = this.searchText().toLowerCase();
    const status = this.selectedStatus();
    return this.shipmentList().filter(item => {
      const matchesStatus = !status || status === this.statusAll.status || item.deliveryStatus.status === status;
      const matchesSearch = !search || item.uploadId.toLowerCase().includes(search) || item.proNumber.toLowerCase().includes(search);
      return matchesSearch && matchesStatus;
    });
  });
  

  async ngOnInit() {
    await this.processShipmentIdFromLink();
    await this.getShipments();
    this.selectedStatus.set(this.statusAll.status);
  }

   async qrCodeCaptured(qrValue: string) {
    this.isCameraOpen = false;
    let result = await this.qrReaderService.qrCodeCaptured(qrValue);
    if (result) {
      this.getShipments();
    }    
  }


  async getShipments(){
    let shipments = await this.dbService.getShipments();
      if(shipments.length === 0){
        this.toastService.info('No shipments found', 'No shipments have been scanned yet. Please scan a shipment to see details here.', 5000);
        this.router.navigate(['/home']);
      }
      this.shipmentList.set(shipments);
  } 


  openDetails(shipment: IShipment){
    this.router.navigate(['/detail'], { state: { data: shipment.id } });
  }

  private async processShipmentIdFromLink() {
    const shipmentIdParam = sessionStorage.getItem(this.pendingShipmentIdKey);

    if (!shipmentIdParam) {
      return;
    }

    const shipmentId = Number(shipmentIdParam);
    if (!Number.isFinite(shipmentId) || shipmentId <= 0) {
      sessionStorage.removeItem(this.pendingShipmentIdKey);
      return;
    }

    sessionStorage.setItem(this.pendingShipmentIdKey, shipmentId.toString());

    await this.qrReaderService.qrCodeCaptured(shipmentId.toString());

    await this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { shipmentId: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });

    sessionStorage.removeItem(this.pendingShipmentIdKey);
  }

}
